import axios from "axios";
import api from "../../../../services/axios";

export const GetOrganizations = async () => {
  try {
    const res = await api.get("/Admin/MasterData/organizations");
    return res?.data;
  } catch (error) {
    throw error?.response?.data;
  }
};

export const CreateOrganization = async (organizationName) => {
  try {
    const res = await api.post("/Admin/MasterData/organization/create", {
      organizationName,
    });
    return res?.data;
  } catch (error) {
    throw error?.response?.data;
  }
};

export const UpdateOrganization = async (payload) => {
  try {
    const res = await api.post("/Admin/MasterData/organization/update", payload);
    return res?.data;
  } catch (error) {
    throw error?.response?.data;
  }
};

export const GetSources = async () => {
  try {
    const res = await api.get("/Admin/MasterData/sources");
    return res?.data;
  } catch (error) {
    throw error?.response?.data;
  }
};

export const CreateSource = async (source) => {
  try {
    const res = await api.post("/Admin/MasterData/source/create",{ source });
    return res?.data;
  } catch (error) {
    throw error?.response?.data;
  }
};

export const UpdateSource = async (payload) => {
  try {
    const res = await api.post("/Admin/MasterData/source/update", payload);
    return res?.data;
  } catch (error) {
    throw error?.response?.data;
  }
};
